import { SuperAdminConstants } from '../../../_constants';

const initialState = { removeOrgAdminLoading: true, data: '', error: false };

export function removeOrgAdmin(state = initialState, action) {

    switch (action.type) {
        case SuperAdminConstants.REQUEST_REMOVE_ORG_ADMIN:
            return {
                removeOrgAdminLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_REMOVE_ORG_ADMIN:
            return {
                removeOrgAdminLoading: false,
                data: action.removeOrgAdmin,
                error: false
            };
        case SuperAdminConstants.REMOVE_ORG_ADMIN_ERROR:
            return {
                removeOrgAdminLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/ManageOrgAdmins/removeOrgAdmin.reducer.js